import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import global from "@/utils/global";
import regexp from "@/utils/regexp";
import filters from "@/filters/index";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';
import VueQuillEditor from "vue-quill-editor";
import "amfe-flexible";

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

//全局样式
import "./assets/css/reset.css";
import { ImagePreview } from 'vant';
Vue.use(require("vue-wechat-title"));
Vue.use(ImagePreview);
//引入过滤器
Vue.use(filters);

Vue.use(VueQuillEditor);
;
Vue.config.productionTip = false;
Vue.prototype.$global = global;
Vue.prototype.$regexp = regexp;

import { getSessionStore } from "@/utils/sessionStorage"
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  console.log('to',to.path)
  let token = getSessionStore("access_token")
  if(token){
    next();
  }else{
    if (to.path !== "/login"//登录
    && to.path !=="/unitLogin"//单位登录
    && to.path !=="/memberInfo"//会员证扫码会员信息
    && to.path !=="/person"//个人注册
    && to.path !=="/group" //单位注册
    && to.path !=="/onlinePayment" //微信支付汇报
    && to.path !=="/personRule"//入会须知
    && to.path !=="/groupRule"//单位入会须知
    && to.path !=="/getPassword"//忘记密码
    && to.path !== "/PaymentList"//支付
    && to.path !== "/MeetingList"
    
    ) {
      next("/login");
    }else{
      next()
    }
     
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
